module.exports = __webpack_public_path__ + "img/_DSC1157.95c51ec9.jpg";